<template>
  <div class="bg-brand-darker container-padding-x">
    <div class="max-w-5xl mx-auto py-24 text-center">
      <slot name="body" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetPromoBanner'
}
</script>

